/**
 * Allowed calendar grid intervals in minutes.
 *
 * Constrained to divisors of 60 so the day grid (`1440 / interval` cells) and
 * the per-hour subdivision (`60 / interval` cells) both stay integral. Both the
 * visible grid lines and the drag snap step in the week/day calendar views read
 * this single value, so they can never disagree.
 */
export const CALENDAR_INTERVAL_VALUES = [5, 10, 15, 20, 30, 60];
/**
 * Default grid interval for a new office location (minutes).
 */
export const DEFAULT_CALENDAR_INTERVAL = 20;
//# sourceMappingURL=calendar-interval.const.js.map